'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;

    this.page = 1;
    this.params = {
      offset: this.page - 1,
      limit: 20,
      sortBy: 'createdAt',
      order: -1,
      group: 1
    };
  }

  $onInit() {
    if (this.$stateParams.page) {
      this.page = this.$stateParams.page;
    }
    this.getFonts();
  }

  getFonts() {
    this.params.offset = (this.page - 1) * this.params.limit;
    this.$http.get('/api/fonts', {
      params: this.params
    }).then(res => {
      this.fonts = res.data;
      this.fonts.list = this.fonts.list.map(item => {
        if (item.modelGroups) {
          item.modelGroups = item.modelGroups.map(a => a.name).join(',')
        }
        return item
      })
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/fonts/${id}`).then(res => {
        this.getFonts();
      });
    }
  }

  pageChanged() {
    this.$state.go('fonts.list', {
      page: this.page
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/fonts/list/list.controller.js